import { motion } from "framer-motion";

const POINTS = ["Tu connais le client.", "Tu as identifié son besoin.", "Tu as sa confiance."];

export const Psychological = () => {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-5xl"
        >
          Tu as déjà fait le plus difficile.
        </motion.h2>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          {POINTS.map((p, i) => (
            <motion.span
              key={p}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.15 + i * 0.12 }}
              className="rounded-2xl border border-black/5 bg-[#FAFAFA] px-6 py-3 text-base font-semibold text-ink"
            >
              {p}
            </motion.span>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-ink/60"
        >
          Leadzi te permet simplement de{" "}
          <span className="font-bold text-brand">valoriser cette opportunité</span>{" "}
          lorsque tu ne peux pas la traiter toi-même.
        </motion.p>
      </div>
    </section>
  );
};
